import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { issueReducer } from './store';

@NgModule({
  imports: [StoreModule.forFeature(`issue`, issueReducer)]
})
export class IssueStateModule {}
